import React, { useState, useEffect } from 'react'
import Cell from '../../molecules/Cell/Cell'
import { api } from '../../../utils/index'
import { GETPRODOTTOVALUES, PRODOTTI, PROSSIMIARRIVI } from '../../../utils/endpoint'
import Loading from '../../atoms/Loading/Loading'
import { useContext } from 'react'
import { QuantitaContext } from '../../../context/QuantitaContext'
import { DatatableRow } from '../../atoms/Datatable/Datatable'
import ModificaArticoli from '../ModificaArticoli/ModificaArticoli'
import NewModal from '../../molecules/NewModal/NewModal'
import { useRouter } from 'next/router'
import { useSelector } from 'react-redux'

const ModalContentQuantita = React.memo(
  ({ carrello_main, id, setVisible, isVisible, SubmitChanges }) => {
    const [prodotto, setProdotto] = useState(null)
    const [quantita, setQuantita] = useState(0)
    const [nuoviArrivi, setNuoviArrivi] = useState([])
    const [riga, setRiga] = useState(null)
    const [neutra, setNeutra] = useState(null)
    const [initialQuantita, setInitialQuantita] = useState(null)
    const router = useRouter()
    const [loading, setLoading] = useState(true)
    const { service_gift } = useSelector((state) => state?.servicegift)
    const GetRigaCarrello = () => {
      let riga = carrello_main.righe_carrello_merce_neutra.filter((item) => item.id == id)

      if (riga.length === 0) {
        const riga_personalizzata = carrello_main.personalizzazioni_carrello
          .map((item) => {
            const result = item.righe_carrello.filter((element) => element.id === id)
            if (result.length > 0) {
              return result[0]
            }
          })
          .filter((item) => item !== undefined && item !== null)

        return Object.assign({}, { riga: riga_personalizzata[0], neutra: false })
      } else {
        return Object.assign({}, { riga: riga[0], neutra: true })
      }
    }

    useEffect(async () => {
      const { riga, neutra } = GetRigaCarrello()
      const response = await api
        .get(`${PRODOTTI}${riga?.articolo?.codice}`, {
          params: { lang: router.lang },
        })
        .catch((err) => {
          console.log(err)
          setVisible(false)
        })
      const product = await response?.data?.articoli.filter(
        (item) => item.codice == riga.articolo.codice
      )[0]
      const params = {
        articoli_ids: [product?.id],
      }
      await api.get(GETPRODOTTOVALUES, { params }).then(
        (response) =>
          response.data &&
          response.data.forEach((element) => {
            if (product.id == element.articolo__id) {
              product.prezzo = element.prezzo
              product.disponibilita = element.disponibilita
            }
          })
      )

      let arrivi = []
      product.prossimi_arrivi = []

      await api.get(PROSSIMIARRIVI, { articoli_ids: [product.id] }).then((response) => {
        response.data &&
          response.data?.forEach((element) => {
            product.id === element.articolo_id && arrivi.push(element)
          })
      })
      product.prossimi_arrivi = arrivi
      setNuoviArrivi(arrivi)
      setProdotto(product)
      setQuantita(riga.quantita)
      setRiga(riga)
      setNeutra(neutra)
      setInitialQuantita(riga.quantita)
      setLoading(false)
    }, [])

    return (
      <>
        {!loading ? (
          <ModificaArticoli
            initialQuantitaProps={quantita}
            initialId={id}
            initialStep={1}
            initialSelectedArticolo={prodotto}
            isVisible={isVisible}
            setVisible={setVisible}
            preventivo={carrello_main}
            prodotto={prodotto}
            SubmitFromProps={SubmitChanges}
            service_gift={service_gift}
          />
        ) : (
          <NewModal visible={loading ? true : false}>
            <Loading />
          </NewModal>
        )}
      </>
    )
  }
)

export default ModalContentQuantita
